import { render, staticRenderFns } from "./ProductPrice.vue?vue&type=template&id=76fd3172&"
import script from "./ProductPrice.vue?vue&type=script&lang=js&"
export * from "./ProductPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports